module.exports = {"410173108":"张庄镇","410173113":"八岗镇","410173116":"三官庙镇","410173202":"八千乡","410173203":"龙王乡","410173400":"新港","410173401":"郑港","410173404":"银河","410173405":"明港","410173580":"滨河","410173581":"冯堂","410173582":"清河","410173583":"龙港"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410173.json
// module id = 1522
// module chunks = 0